import { connect } from 'react-redux'

import {
  getOnboardingChecklist,
  isOrganizationHasStories,
  isSMSAvailable,
  isPreTrackSurveyEnabled,
  isPostTrackSurveyEnabled,
  isIntegratedType,
} from 'store/entities/identity/selectors'
import OnboardingChecklist from './OnboardingChecklist'
import { modal } from 'store/entities/modal/actions'
import { isOpen, restProps } from 'store/entities/modal/selectors'
import { getCheckListAvailabilityParams } from 'helpers/onboarding'
// @ts-ignore
import { getUIWindowSizesWidth } from 'store/entities/ui/selectors'

const mapStateToProps = (state: any) => {
  const title = restProps(state)?.title
  const onboardingChecklist = getOnboardingChecklist(state)
  const isFirstActionCompleted = onboardingChecklist.get('isFirstActionCompleted')
  const isStoryShared = onboardingChecklist.get('isStoryShared')
  const isMobileNumberAdded = onboardingChecklist.get('isMobileNumberAdded')
  const areNotificationSettingsUpdated = onboardingChecklist.get('areNotificationSettingsUpdated')
  const isQuizCompleted = onboardingChecklist.get('isQuizCompleted')
  const checklist = {
    isFirstActionCompleted,
    isStoryShared,
    isMobileNumberAdded,
    areNotificationSettingsUpdated,
    isQuizCompleted,
  }

  const featureAvailabilityParams = {
    isSurveyEnabled: isPreTrackSurveyEnabled(state) || isPostTrackSurveyEnabled(state),
    isStoriesEnabled: isOrganizationHasStories(state),
    isSMSEnabled: isSMSAvailable(state),
    isIntegratedType: isIntegratedType(state),
  }
  const { completedNumber, availableOrgFeatureNumber } = getCheckListAvailabilityParams({
    checklist,
    featureAvailabilityParams,
  })

  return {
    // @ts-ignore
    isModalOpen: isOpen && title === 'Onboarding Checklist',
    checklist,
    featureAvailabilityParams,
    completedNumber,
    availableOrgFeatureNumber,
    windowWidth: getUIWindowSizesWidth(state),
  }
}

const mapDispatchToProps = {
  showModal: modal.show,
}

export default connect(mapStateToProps, mapDispatchToProps)(OnboardingChecklist)
